import { render, staticRenderFns } from "./BackgroundPicker.vue?vue&type=template&id=6597959a&scoped=true&"
import script from "./BackgroundPicker.vue?vue&type=script&lang=js&"
export * from "./BackgroundPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6597959a",
  null
  
)

export default component.exports